import {
  ROUTE_USER_PROFILE,
  ROUTE_USER_NOTIFICATIONS,
  ROUTE_USER_BETA_LAB,
  ROUTE_PLANS,
  ROUTE_USER_SUBSCRIPTION,
  ROUTE_USER_SUBSCRIPTION_AND_BILLING,
} from '@/constants/routes';
import type { SubNavRoute } from '@/constants/routes';

export const accountRoutes: SubNavRoute[] = (() => {
  const routes = [
    {
      to: ROUTE_USER_PROFILE,
      label: 'Profile',
    },
    ...(RUNTIME_ENV !== 'native'
      ? [
          {
            to: ROUTE_USER_SUBSCRIPTION_AND_BILLING,
            label: 'Subscription & Billing',
          },
          { to: ROUTE_PLANS, label: 'Plans & Pricing' },
          { to: ROUTE_USER_SUBSCRIPTION, label: 'Manage Subscription' },
        ]
      : [{ to: ROUTE_PLANS, label: 'My Plan' }]),
    {
      to: ' ',
      label: 'Viewed Companies',
    },
    {
      to: ROUTE_USER_NOTIFICATIONS,
      label: 'Notifications',
    },
  ];
  if (RUNTIME_ENV !== 'native') {
    routes.push({
      to: ROUTE_USER_BETA_LAB,
      label: 'Beta Lab',
    });
  }
  return routes;
})();
